import React, { useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import { colors } from '@constants/colors';
import { Icon } from '@mui';
import NewBaseListItem from './base-list-item';
import './list-item.scss';

const LayerListItem = ({ id, name, segments, onClick, customOnClick, onMouseEnter, onMouseLeave, ...otherProps }) => {
  const handleClick = useCallback(() => {
    if (customOnClick) {
      customOnClick();
    } else if (onClick) {
      onClick('layer', id, segments);
    }
  }, [customOnClick, id, onClick, segments]);

  const renderTypeIcon = useCallback(() => (
    <div styleName="icon type-icon">
      <Icon
        color={colors.opacity.black0_6}
        aria-hidden="true"
        style={{ fontSize: 16 }}
      >
        layers
      </Icon>
    </div>
  ), []);

  return (
    <NewBaseListItem
      {...otherProps}
      id={id}
      name={name}
      entityTypeName="layer"
      onClick={handleClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      renderContent={() => null}
      renderFooter={() => null}
      renderTypeIcon={renderTypeIcon}
      titleName={name}
    />
  );
};

LayerListItem.propTypes = {
  customOnClick: PropTypes.func,
  id: PropTypes.number,
  name: PropTypes.string,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  segments: PropTypes.array
};

export default memo(LayerListItem);
